import React from 'react'
import styles from '../../../styles/modules/table.module.scss'
import formStyles from '../../../styles/modules/each-item/each-item-forms.module.scss'

interface Props {
  title: string
  value: string | number | undefined
  inputName: string
  inputType?: string
  disabled?: boolean
  onChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void
}

const ItemRowInput: React.FC<Props> = props => {
  return (
    <tr className={styles.inputRowStatic}>
      <td className={styles.inputCell}>{props.title}</td>
      <td
        className={
          props.inputType === 'textarea'
            ? styles.itemInputCell
            : styles.inputCell
        }
      >
        {props.inputType === 'textarea' ? (
          <textarea
            className={formStyles.textInput}
            value={props.value || ''}
            onChange={props.onChange}
            name={props.inputName}
            disabled={props.disabled}
          />
        ) : (
          <input
            className={`${
              props.inputType === 'textarea'
                ? formStyles.textInput
                : formStyles.input
            }`}
            value={props.value || ''}
            onChange={props.onChange}
            name={props.inputName}
            disabled={props.disabled}
          />
        )}
      </td>
    </tr>
  )
}

export default ItemRowInput
